<template>
    <products-list @onFetchRequested="onFetchRequested"
                   @onHistoryPushed="onHistoryPushed"
                   :searchResponse="searchResponse"
                   :languageId="languageId"></products-list>
</template>

<script lang="ts" src="./SearchProductsByFamily.vue.ts"></script>
